import React from "react";
import LegalDoc from "../../components/LegalDoc";
import PublicNavbar from "../../components/PublicNavbar";
import UserNavbar from "../../components/UserNavbar";
import Footer from "../../components/Footer";
import { useAuth } from "../../utils/AuthContext";

const PrivacyPolicy: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      {isAuthenticated ? <UserNavbar /> : <PublicNavbar />}
      <LegalDoc fileName="privacy-policy.txt" documentType="Privacy Policy" />
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
